module.exports = __webpack_public_path__ + "img/watch-orange.fc32438b.svg";